import { authHeader, handleResponse } from 'helpers';
import { apiConstants } from '../constants';
import { queryFilters, queryWhere } from '../helpers/util';

export const permissionService = {
  get,
  getAll,
  add,
  update,
  remove,
  getLoggedAccountPermissions
};


function get(permission_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  if (permission_id)
    var url = apiConstants.getPermission.replace(':permission_id', permission_id)
  return fetch(url, requestOptions)
    .then(handleResponse);
}

function getAll(limit, page, filters = undefined) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  var url = apiConstants.getPermissions;
  var queryfilters = queryFilters(limit, page);
  if (filters) queryfilters = queryfilters.concat('', queryWhere(filters));
  return fetch(`${url}${queryfilters}`, requestOptions)
    .then(handleResponse);

}

function add(permissionValues) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(permissionValues)
  };

  var url = apiConstants.addPermission;
  return fetch(`${url}`, requestOptions)
    .then(handleResponse);
}

function update(permission_id, updatedValues) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(updatedValues)
  };

  var url = apiConstants.updatePermission.replace(':permission_id', permission_id)
  return fetch(url, requestOptions)
    .then(handleResponse);
}


function remove(permission_id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };
  var url = apiConstants.deletePermission.replace(':permission_id', permission_id)
  return fetch(url, requestOptions)
    .then(handleResponse);
}


function getLoggedAccountPermissions() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  var url = apiConstants.getLoggedAccountPermissions;
  return fetch(`${url}?coded=true`, requestOptions)
    .then(handleResponse);

}
